module.exports = __webpack_public_path__ + "img/b4974bf.jpg";